import AdditionalService from '@/components/booking/logic/AdditionalService'

export default {
  data () {
    return {
      dx: { service: new AdditionalService(this.value, this.offer) },
    }
  },
  created () {
    this.setAdditionalServices(this.dx.service.data)
  },
  computed: {
    services () {
      return this.additionalServices.find(service => service.code == this.value.Code).services
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/booking/logic/Services.js